import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import {
    fetchTakeDown,
    fetchTakeDownAction
} from "../../actions/customer";
import { Link, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";


const TakeDown = () => {
    const dispatch = useDispatch();

    var date = new Date();
    date = moment(date).add(1, 'year').toDate();
    const [isModal, setModal] = useState(false);
    const [isModalTwo, setisModalTwo] = useState('');
    const [updateId, setUpdateId] = useState('');
    const [reminderModal, setReminderModal] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState("");
    const [approvalId, setApprovalId] = useState("");
    const [emailId, setEmailId] = useState("");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [filterData, setfilterData] = useState("all");
    const [moduleName, setModuleName] = useState("all");
    const [totalItems, setTotalItems] = useState(0);
    const [status, setStatus] = useState("");
    const [comment, setComment] = useState("");
    const [reason, setReason] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);


    let customers = useSelector((state) => state?.customer?.takeDown?.data?.tickets || []);
    const pagination = useSelector((state) => state?.customer?.takeDown?.data?.pagination || {});

    useEffect(() => {
        setIsTableLoading(true);
        fetchTakeDown(dispatch, page, limit, search, filterData, moduleName).finally(() => {
            setIsTableLoading(false);
        });
    }, [page, limit, search, filterData, moduleName]);

    useEffect(() => {
        setTotalItems(pagination?.total || 0);
    }, [pagination]);


    // Helper function to extract user comment from comments array
    const getUserComment = (ticket) => {
        if (!ticket?.comments || !Array.isArray(ticket.comments)) return null;
        const userComment = ticket.comments.find(c => c.type === 'user');
        return userComment?.comment || null;
    };

    // Helper function to get URL/link based on module type
    const getTicketUrl = (ticket) => {
        if (!ticket?.recordData) return 'N/A';
        
        const module = ticket.moduleName;
        const recordData = ticket.recordData;
        
        if (module === 'lookalike') {
            return recordData.lookalike || recordData.url || 'N/A';
        } else if (module === 'social_media_profiles') {
            return recordData.link || recordData.url || 'N/A';
        } else if (module === 'rogue_mobile_applications') {
            return recordData.url || recordData.website || 'N/A';
        }
        
        return recordData.url || recordData.link || recordData.lookalike || 'N/A';
    };

    // Helper function to get display name based on module type
    const getTicketDisplayName = (ticket) => {
        if (!ticket?.recordData) return 'N/A';
        
        const module = ticket.moduleName;
        const recordData = ticket.recordData;
        
        if (module === 'lookalike') {
            return recordData.lookalike || 'N/A';
        } else if (module === 'social_media_profiles') {
            return recordData.name || recordData.link || 'N/A';
        } else if (module === 'rogue_mobile_applications') {
            return recordData.app_name || recordData.url || 'N/A';
        }
        
        return 'N/A';
    };

    // Server-side pagination, so we use the data directly
    let mapData = customers;
    let currentTableData = customers;
    
    const downloadCsvData = customers?.map((res) => ({
        Organisation: res?.organisationName || 'N/A',
        Module: res?.moduleName || 'N/A',
        UserComment: getUserComment(res) || 'N/A',
        Status: res?.status || 'N/A',
        CreatedAt: res?.createdAt ? moment(res.createdAt).format("DD/MM/YYYY hh:mm a") : 'N/A',
        URL: getTicketUrl(res),
        Original: res?.recordData?.original || 'N/A',
        AppName: res?.recordData?.app_name || 'N/A',
        Collection: res?.collectionName || 'N/A'
    }));

    const handleSearchChange = (e) => {
        const inputValue = e.target.value;
        setSearchInput(inputValue);
        clearTimeout(handleSearchChange.timeoutId);
        handleSearchChange.timeoutId = setTimeout(() => {
            setSearch(inputValue);
            setPage(1);
        }, 1000);
    };

    const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        FileSaver.saveAs(data, fileName + ".xlsx");
    };

    // Download ticket report from backend API
    const downloadTicketReport = async () => {
        if (isDownloading) return;
        setIsDownloading(true);

        try {
            const session = localStorage.getItem("session");
            const response = await axios.get(`${API_URL}/ticket/download-report`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${session}`,
                },
                params: {
                    status: filterData !== "all" ? filterData : undefined,
                    moduleName: moduleName !== "all" ? moduleName : undefined,
                    search: search || undefined,
                },
            });

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            FileSaver.saveAs(blob, `takedown-requests-${moment().format("YYYY-MM-DD")}.xlsx`);
        } catch (error) {
            toastr.error(
                "Error",
                error?.response?.data?.userMessage || "Failed to download report"
            );
        } finally {
            setIsDownloading(false);
        }
    };

    const getCurrentTicket = () => {
        return customers.find(t => t._id === updateId);
    };

    const resetForm = () => {
        setStatus('');
        setComment('');
        setReason('');
        setIsSubmitting(false);
        setHasUnsavedChanges(false);
    };

    const handleFormChange = () => {
        setHasUnsavedChanges(true);
    };

    const handleModalClose = () => {
        if (hasUnsavedChanges) {
            if (window.confirm('You have unsaved changes. Are you sure you want to close?')) {
                setisModalTwo('');
                resetForm();
            }
        } else {
            setisModalTwo('');
            resetForm();
        }
    };

    const setModalUpdate = (id) => {
        setUpdateId(id)
        setisModalTwo('Form Wizard modal two')
        resetForm();
    }

    const submit = () => {
        if (status == "") {
            toastr.error("Error", 'Please select the status');
            return
        }
        
        // Additional validation for rejected status
        if (status === 'rejected' && !reason.trim()) {
            toastr.error("Error", 'Please provide a reason for rejection');
            return;
        }
        
        // Additional validation for other statuses
        if (status !== 'rejected' && !comment.trim()) {
            toastr.error("Error", 'Please provide a comment');
            return;
        }
        
        // Confirm status change
        const currentTicket = getCurrentTicket();
        const confirmMessage = `Are you sure you want to change the status from "${currentTicket?.status || 'N/A'}" to "${status}"?`;
        
        if (!window.confirm(confirmMessage)) {
            return;
        }
        
        setIsSubmitting(true);
        
        // Find the ticket to get organisationId
        const ticket = customers.find(t => t._id === updateId);
        if (!ticket) {
            toastr.error("Error", 'Ticket not found');
            setIsSubmitting(false);
            return;
        }

        let data = {
            organisationId: ticket.organisationId,
            status: status
        };

        // Add comment based on status
        if (status === 'rejected' && reason) {
            data.comment = reason;
        } else if (comment) {
            data.comment = comment;
        }

        // Call the API with proper error handling
        fetchTakeDownAction(dispatch, updateId, data)
            .then((res) => {
                if (res && !res.error) {
                    const successMessage = `Ticket status updated to "${status}" successfully`;
                    toastr.success("Success", res.userMessage || successMessage);
                    setisModalTwo('');
                    // Reset form fields
                    resetForm();
                    // Refresh the data
                    fetchTakeDown(dispatch, page, limit, search, filterData, moduleName);
                } else {
                    toastr.error("Error", res?.userMessage || 'Failed to update ticket');
                }
            })
            .catch((error) => {
                // console.error removed
                toastr.error("Error", error?.message || 'Failed to update ticket');
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }


    return (
        <div className="container-fluid">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Take Down Requests</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/" className="welcome-textSmall">Home</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Take Down Requests
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right">
                        <div className="mt-3">
                            <span className="badge badge-info badge-lg">
                                Total: {totalItems || 0} requests
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-12 col-md-12">
                    <div className="card">
                        <div className="body">
                            <div className="row clearfix">
                                <div className="col-sm-3 mb-2">
                                    <select
                                        className="custom-select custom-select-sm form-control form-control-sm"
                                        value={filterData}
                                        onChange={(e) => {
                                            setfilterData(e.target.value);
                                            setPage(1);
                                        }}
                                    >
                                        <option value="all">All Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="inProgress">In Progress</option>
                                        <option value="completed">Completed</option>
                                        <option value="rejected">Rejected</option>
                                    </select>
                                </div>
                                <div className="col-sm-3 mb-2">
                                    <select
                                        className="custom-select custom-select-sm form-control form-control-sm"
                                        value={moduleName}
                                        onChange={(e) => {
                                            setModuleName(e.target.value);
                                            setPage(1);
                                        }}
                                    >
                                        <option value="all">All Modules</option>
                                        <option value="lookalike">Lookalike</option>
                                        <option value="social_media_profiles">Social Media Profiles</option>
                                        <option value="rogue_mobile_applications">Rogue Mobile Applications</option>
                                    </select>
                                </div>
                                <div className="col-sm-3 mb-2">
                                    <div className="searchBoxInput p-0">
                                        <input
                                            className="form-control form-control-sm ml-0 my-1"
                                            type="text"
                                            placeholder="Search..."
                                            aria-label="Search"
                                            value={searchInput}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-3 mb-2">
                                    {customers?.length === 0 ? null : (
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                downloadTicketReport();
                                            }}
                                            className="btn btn-sm btn-primary mr-1 download-report"
                                            disabled={isDownloading}
                                        >
                                            {isDownloading ? "Downloading..." : "Download Report"}
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                    <tbody>
                                        <tr>
                                            <th>Organisation</th>
                                            <th>Module</th>
                                            <th>User Comment</th>
                                            <th>Target URL/Name</th>
                                            <th>Original/Reference</th>
                                            <th>Status</th>
                                            <th>Created At</th>
                                            <th>Action</th>
                                        </tr>
                                        {isTableLoading ? (
                                            <tr>
                                                <td colSpan="8" className="text-center">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                    <p className="mt-2">Loading take down requests...</p>
                                                </td>
                                            </tr>
                                        ) : currentTableData && currentTableData.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" className="text-center">
                                                    <div className="alert alert-warning">
                                                        <i className="fa fa-search"></i> No take down requests found matching your search criteria.
                                                        <br />
                                                        <small>Try adjusting your search terms or filters.</small>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            currentTableData?.map((item, index) => {
                                                const userComment = getUserComment(item);
                                                const ticketUrl = getTicketUrl(item);
                                                const displayName = getTicketDisplayName(item);
                                                
                                                return (
                                                    <tr key={item._id}>
                                                        <td>
                                                            <p className="mb-0 font-weight-bold">{item.organisationName || 'N/A'}</p>
                                                        </td>
                                                        <td>
                                                            <span className={`badge badge-${
                                                                item.moduleName === 'lookalike' ? 'danger' :
                                                                item.moduleName === 'social_media_profiles' ? 'info' :
                                                                item.moduleName === 'rogue_mobile_applications' ? 'warning' : 'secondary'
                                                            }`}>
                                                                {item.moduleName ? item.moduleName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'N/A'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span 
                                                                title={userComment || 'No comment'}
                                                                style={{ 
                                                                    display: 'block',
                                                                    maxWidth: '200px',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap'
                                                                }}
                                                            >
                                                                {userComment ? 
                                                                    (userComment.length > 50 ? 
                                                                        userComment.substring(0, 50) + '...' : 
                                                                        userComment
                                                                    ) : <span className="text-muted">No comment</span>
                                                                }
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {ticketUrl !== 'N/A' ? (
                                                                <a 
                                                                    href={ticketUrl.startsWith('http') ? ticketUrl : `https://${ticketUrl}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-danger font-weight-bold"
                                                                    style={{ 
                                                                        display: 'block',
                                                                        maxWidth: '250px',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    }}
                                                                    title={ticketUrl}
                                                                >
                                                                    <i className="fa fa-external-link mr-1"></i>
                                                                    {displayName !== 'N/A' ? displayName : ticketUrl}
                                                                </a>
                                                            ) : (
                                                                <span className="text-muted">N/A</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {item.recordData?.original ? (
                                                                <a 
                                                                    href={item.recordData.original.startsWith('http') ? item.recordData.original : `https://${item.recordData.original}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-success font-weight-bold"
                                                                    title={item.recordData.original}
                                                                >
                                                                    <i className="fa fa-external-link mr-1"></i>
                                                                    {item.recordData.original}
                                                                </a>
                                                            ) : item.recordData?.website ? (
                                                                <a 
                                                                    href={item.recordData.website.startsWith('http') ? item.recordData.website : `https://${item.recordData.website}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-success font-weight-bold"
                                                                    title={item.recordData.website}
                                                                >
                                                                    <i className="fa fa-external-link mr-1"></i>
                                                                    {item.recordData.website}
                                                                </a>
                                                            ) : (
                                                                <span className="text-muted">N/A</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <span className={`badge badge-${
                                                                item.status === 'pending' ? 'warning' :
                                                                item.status === 'inProgress' ? 'info' :
                                                                item.status === 'completed' ? 'success' :
                                                                item.status === 'rejected' ? 'danger' : 'secondary'
                                                            }`}>
                                                                {item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : 'N/A'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="text-muted">
                                                                {item.createdAt ? 
                                                                    moment(item.createdAt).format("DD/MM/YYYY hh:mm a") : 
                                                                    'N/A'
                                                                }
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <button
                                                                onClick={() => setModalUpdate(item?._id)}
                                                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                                                title="Update ticket status"
                                                            >
                                                                <i className="fa fa-edit mr-1"></i>
                                                                Update
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex justify-content-between align-content-center">
                                <div className="dataTables_paginate">
                                    {totalItems > 0 && (
                                        <Pagination
                                            className="pagination-bar"
                                            currentPage={page}
                                            totalCount={totalItems}
                                            pageSize={limit}
                                            onPageChange={(page) => {
                                                setPage(page);
                                            }}
                                        />
                                    )}
                                </div>
                                {totalItems > 10 && (
                                    <select
                                        value={limit}
                                        onChange={(e) => {
                                            setLimit(parseInt(e.target.value));
                                            setPage(1);
                                        }}
                                        className="form-control limitSelectBox"
                                    >
                                        <option value={10}>10 per page</option>
                                        <option value={25}>25 per page</option>
                                        <option value={50}>50 per page</option>
                                        <option value={100}>100 per page</option>
                                    </select>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`modal fade Form-Wizard-modal ${isModal ? "d-block show" : ""
                    }`}
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {approvalStatus == "Approve" ? "Approve?" : "Reject?"}
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>
                                {approvalStatus == "Approve" ? "Are you sure to approve the request." : "Are you sure ro reject the request."}
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-round btn-default"
                                data-dismiss="modal"
                                onClick={() => setModal(false)}
                            >
                                Cancel
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`modal fade Form-Wizard-modal ${reminderModal ? "d-block show" : ""
                    }`}
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Reminder
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>
                                Do you really want to send reminder to this user?
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-round btn-default"
                                data-dismiss="modal"
                                onClick={() => setReminderModal(false)}
                            >
                                Cancel
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""
                    }`}
            >
                <div className="modal-dialog modal-lg" id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Update Take Down Request
                            </h5>
                            {getCurrentTicket() && (
                                <div style={{ marginTop: '5px' }}>
                                    <small className="text-muted">
                                        <strong>Organisation:</strong> {getCurrentTicket().organisationName} | <strong>Module:</strong> {getCurrentTicket().moduleName}
                                    </small>
                                </div>
                            )}
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={handleModalClose}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page modal_mob">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="card">
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="alert alert-info">
                                                <strong>Current Status:</strong> 
                                                <span className={`badge badge-${
                                                    getCurrentTicket()?.status === 'pending' ? 'warning' :
                                                    getCurrentTicket()?.status === 'inProgress' ? 'info' :
                                                    getCurrentTicket()?.status === 'completed' ? 'success' :
                                                    getCurrentTicket()?.status === 'rejected' ? 'danger' : 'secondary'
                                                } ml-2`}>
                                                    {getCurrentTicket()?.status || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        {getUserComment(getCurrentTicket()) && (
                                            <div className="col-md-12">
                                                <div className="alert alert-secondary">
                                                    <strong>User Comment:</strong> 
                                                    <p className="mb-0 mt-2">{getUserComment(getCurrentTicket())}</p>
                                                    {getCurrentTicket()?.comments?.length > 1 && (
                                                        <small className="text-muted">
                                                            <i className="fa fa-info-circle mr-1"></i>
                                                            {getCurrentTicket().comments.length} total comment(s)
                                                        </small>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {getCurrentTicket()?.recordData && (
                                            <div className="col-md-12">
                                                <div className="alert alert-warning">
                                                    <strong>Record Information:</strong> 
                                                    <div className="row mt-2">
                                                        {getCurrentTicket().moduleName === 'lookalike' && (
                                                            <>
                                                                <div className="col-md-6 mb-2">
                                                                    <strong>Lookalike Domain:</strong> 
                                                                    <br />
                                                                    {getCurrentTicket().recordData.lookalike ? (
                                                                        <a 
                                                                            href={`https://${getCurrentTicket().recordData.lookalike}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-danger ml-2"
                                                                        >
                                                                            <i className="fa fa-external-link mr-1"></i>
                                                                            {getCurrentTicket().recordData.lookalike}
                                                                        </a>
                                                                    ) : (
                                                                        <span className="text-muted ml-2">N/A</span>
                                                                    )}
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <strong>Original Domain:</strong> 
                                                                    <br />
                                                                    {getCurrentTicket().recordData.original ? (
                                                                        <a 
                                                                            href={`https://${getCurrentTicket().recordData.original}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-success ml-2"
                                                                        >
                                                                            <i className="fa fa-external-link mr-1"></i>
                                                                            {getCurrentTicket().recordData.original}
                                                                        </a>
                                                                    ) : (
                                                                        <span className="text-muted ml-2">N/A</span>
                                                                    )}
                                                                </div>
                                                                {getCurrentTicket().recordData.phishing_analysis && (
                                                                    <div className="col-md-12 mt-2">
                                                                        <strong>Phishing Score:</strong> 
                                                                        <span className={`badge badge-${
                                                                            getCurrentTicket().recordData.phishing_analysis.phishing_score >= 7 ? 'danger' :
                                                                            getCurrentTicket().recordData.phishing_analysis.phishing_score >= 4 ? 'warning' : 'info'
                                                                        } ml-2`}>
                                                                            {getCurrentTicket().recordData.phishing_analysis.phishing_score}/10
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                        {getCurrentTicket().moduleName === 'social_media_profiles' && (
                                                            <>
                                                                <div className="col-md-6 mb-2">
                                                                    <strong>Profile Link:</strong> 
                                                                    <br />
                                                                    {getCurrentTicket().recordData.link ? (
                                                                        <a 
                                                                            href={getCurrentTicket().recordData.link}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-danger ml-2"
                                                                        >
                                                                            <i className="fa fa-external-link mr-1"></i>
                                                                            {getCurrentTicket().recordData.link}
                                                                        </a>
                                                                    ) : (
                                                                        <span className="text-muted ml-2">N/A</span>
                                                                    )}
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <strong>Platform:</strong> 
                                                                    <span className="badge badge-info ml-2">
                                                                        {getCurrentTicket().recordData.source || 'N/A'}
                                                                    </span>
                                                                </div>
                                                                {getCurrentTicket().recordData.name && (
                                                                    <div className="col-md-12 mt-2">
                                                                        <strong>Profile Name:</strong> 
                                                                        <span className="ml-2">{getCurrentTicket().recordData.name}</span>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                        {getCurrentTicket().moduleName === 'rogue_mobile_applications' && (
                                                            <>
                                                                <div className="col-md-6 mb-2">
                                                                    <strong>App Name:</strong> 
                                                                    <br />
                                                                    <span className="text-danger ml-2 font-weight-bold">
                                                                        {getCurrentTicket().recordData.app_name || 'N/A'}
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <strong>App URL:</strong> 
                                                                    <br />
                                                                    {getCurrentTicket().recordData.url ? (
                                                                        <a 
                                                                            href={getCurrentTicket().recordData.url}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-danger ml-2"
                                                                        >
                                                                            <i className="fa fa-external-link mr-1"></i>
                                                                            {getCurrentTicket().recordData.url}
                                                                        </a>
                                                                    ) : (
                                                                        <span className="text-muted ml-2">N/A</span>
                                                                    )}
                                                                </div>
                                                                {getCurrentTicket().recordData.website && (
                                                                    <div className="col-md-12 mt-2">
                                                                        <strong>Original Website:</strong> 
                                                                        <a 
                                                                            href={getCurrentTicket().recordData.website.startsWith('http') ? getCurrentTicket().recordData.website : `https://${getCurrentTicket().recordData.website}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-success ml-2"
                                                                        >
                                                                            <i className="fa fa-external-link mr-1"></i>
                                                                            {getCurrentTicket().recordData.website}
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {status && (
                                            <div className="col-md-12">
                                                <div className="alert alert-primary">
                                                    <strong>Update Summary:</strong>
                                                    <div className="mt-2">
                                                        <strong>New Status:</strong> 
                                                        <span className={`badge badge-${
                                                            status === 'pending' ? 'warning' :
                                                            status === 'inProgress' ? 'info' :
                                                            status === 'completed' ? 'success' :
                                                            status === 'rejected' ? 'danger' : 'secondary'
                                                        } ml-2`}>
                                                            {status}
                                                        </span>
                                                    </div>
                                                    {status === 'rejected' && reason && (
                                                        <div className="mt-1">
                                                            <strong>Rejection Reason:</strong> {reason}
                                                        </div>
                                                    )}
                                                    {status !== 'rejected' && comment && (
                                                        <div className="mt-1">
                                                            <strong>Admin Comment:</strong> {comment}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="col-lg-6 col-md-12">New Status</label>
                                                <div className="form-group ol-lg-12 col-md-12">
                                                    <select
                                                        className="custom-select custom-select-sm form-control form-control-sm"
                                                        value={status}
                                                        onChange={(e) => {
                                                            setStatus(e.target.value);
                                                            handleFormChange();
                                                        }}
                                                    >
                                                        <option value="">Please select the status</option>
                                                        <option value="pending" disabled={getCurrentTicket()?.status === 'pending'}>
                                                            Pending {getCurrentTicket()?.status === 'pending' ? '(Current)' : ''}
                                                        </option>
                                                        <option value="inProgress" disabled={getCurrentTicket()?.status === 'inProgress'}>
                                                            In Progress {getCurrentTicket()?.status === 'inProgress' ? '(Current)' : ''}
                                                        </option>
                                                        <option value="rejected" disabled={getCurrentTicket()?.status === 'rejected'}>
                                                            Rejected {getCurrentTicket()?.status === 'rejected' ? '(Current)' : ''}
                                                        </option>
                                                        <option value="completed" disabled={getCurrentTicket()?.status === 'completed'}>
                                                            Completed {getCurrentTicket()?.status === 'completed' ? '(Current)' : ''}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {status == 'rejected' ? <>
                                            <div className="col-md-12">
                                                <label className="col-lg-12 col-md-12">Reason for Rejection <span className="text-danger">*</span></label>
                                                <div className="form-group col-lg-12 col-md-12">
                                                    <textarea
                                                        onChange={(e) => {
                                                            setReason(e.target.value);
                                                            handleFormChange();
                                                        }}
                                                        value={reason}
                                                        className="form-control"
                                                        rows="3"
                                                        placeholder="Please provide a detailed reason for rejecting this take-down request..."
                                                        required
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </> : <>
                                            <div className="col-md-12">
                                                <label className="col-lg-12 col-md-12">Admin Comment <span className="text-danger">*</span></label>
                                                <div className="form-group col-lg-12 col-md-12">
                                                    <textarea
                                                        onChange={(e) => {
                                                            setComment(e.target.value);
                                                            handleFormChange();
                                                        }}
                                                        value={comment}
                                                        className="form-control"
                                                        rows="3"
                                                        placeholder="Please provide a comment about this take-down request..."
                                                        required
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </>}
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-lg-12 col-md-12"
                                            style={{ marginRight: "28px" }}
                                        >
                                            <button
                                                type="button"
                                                style={{ color: "black", fontWeight: "bold" }}
                                                onClick={submit}
                                                disabled={isSubmitting}
                                                className="btn btn-round btn-primary mr-1 pull-right"
                                            >
                                                {isSubmitting ? 'Updating...' : 'Submit'}
                                            </button>
                                            &nbsp;&nbsp;
                                            <button
                                                type="button"
                                                onClick={handleModalClose}
                                                className="btn btn-round btn-default pull-right"
                                                style={{ marginRight: "10px" }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TakeDown;
